import { ICreateInventoryProductResponse, IEditInventoryProductResponse, IInventoryActionOtpResponse, IInventoryActionPayload, IInventoryActionResponse, IInventoryBrandListResponse, IInventoryProductLogsResponse, IInventoryProductPayload, InventoryProductListResponse } from "../../../features/inventoryManagement/products/types";
import ApiService from "../../ApiService";
import { IEmployeeAssetsResponse } from "../../../features/inventoryManagement/products/types";

export enum InventoryProductEndpoints {
    URL = "/inventory-products",
    INVENTORY_ACTION = "/inventory/action",
    INVENTORY_ITEM_LOGS_BASE = "/inventory-items",
    INVENTORY_PRODUCT_OTP = "/inventory/action-otp/send",
    BRANDS = "/inventory-brands",
}

// Params for fetching products (for pagination and filters)
export interface GetProductsParams {
    page?: number;
    size?: number;
    status?: string;
    category_id?: number;
    vendor_id?: number;
    search_keyword?: string;
    user_id?: number;
}

class InventoryProductService extends ApiService {
    async getMyAssets(): Promise<IEmployeeAssetsResponse> {
        return this.get<IEmployeeAssetsResponse>(`${InventoryProductEndpoints.URL}/my-assets`);
    }
    async getEmployeeAssets(userId: number): Promise<IEmployeeAssetsResponse> {
        const assets: IEmployeeAssetsResponse["data"] = [];
        let page = 1;
        let lastPage = 1;
        do {
            const response = await this.getProducts({ user_id: userId, page, size: 100 });
            if (!response.status) return { status: false, message: response.message ?? "Unable to load employee assets.", data: [] };
            assets.push(...response.data.data.filter((asset) => Number(asset.owner_id) === userId));
            lastPage = response.data.last_page;
            page += 1;
        } while (page <= lastPage);
        return { status: true, message: "Employee assets fetched successfully.", data: assets };
    }
    async getProducts(
        params?: GetProductsParams
    ): Promise<InventoryProductListResponse> {
        const queryParams = new URLSearchParams();

        // Pagination Params
        if (params?.page) queryParams.append("page", String(params.page));
        if (params?.size) queryParams.append("size", String(params.size));

        // Filter Params
        if (params?.status)
            queryParams.append("status", params.status);
        if (params?.category_id)
            queryParams.append("category_id", String(params.category_id));
        if (params?.vendor_id)
            queryParams.append("vendor_id", String(params.vendor_id));
        if (params?.search_keyword)
            queryParams.append("search_keyword", params.search_keyword);
        if (params?.user_id) queryParams.append("user_id", String(params.user_id));

        const queryString = queryParams.toString();
        const url = `${InventoryProductEndpoints.URL}${queryString ? `?${queryString}` : ""}`;

        return this.get<InventoryProductListResponse>(url);
    }

    async createInventoryProduct(formData: FormData): Promise<ICreateInventoryProductResponse> {
        return this.post<ICreateInventoryProductResponse>(InventoryProductEndpoints.URL, formData);
    }

    async updateInventoryProduct(id: number, formData: FormData): Promise<ICreateInventoryProductResponse> {
        return this.post<ICreateInventoryProductResponse>(`${InventoryProductEndpoints.URL}/${id}`, formData);
    }

    async getEditInventoryProduct(id: number): Promise<IEditInventoryProductResponse> {
        return this.get<IEditInventoryProductResponse>(`${InventoryProductEndpoints.URL}/${id}`);
    }

    async inventoryAction(formData: FormData): Promise<IInventoryActionResponse> {
        return this.post<IInventoryActionResponse>(InventoryProductEndpoints.INVENTORY_ACTION, formData);
    }

    async getLogsByProductId(productId: number): Promise<IInventoryProductLogsResponse> {
        const url = `${InventoryProductEndpoints.INVENTORY_ITEM_LOGS_BASE}/${productId}/logs`;

        return this.get<IInventoryProductLogsResponse>(url);
    }

    async sendInventoryActionOtp(payload: {inventory_item_id: number;action: string;receiver_id: number;}): Promise<IInventoryActionOtpResponse> {
        return this.post<IInventoryActionOtpResponse>(InventoryProductEndpoints.INVENTORY_PRODUCT_OTP,payload);
    }

    async getBrands(): Promise<IInventoryBrandListResponse> {
        return this.get<IInventoryBrandListResponse>(InventoryProductEndpoints.BRANDS);
    }


}
export const inventoryProductService = new InventoryProductService();
